module.exports = __webpack_public_path__ + "static/img/customs_banner_iphone_in.8f3801c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/customs_banner_iphone_in.png
// module id = W6id
// module chunks = 1